<template>
    <v-container>
        <!-- div for help to place filter card -->
        <div class="mt-n16 white--text">.</div>

        <!-- filter -->
        <v-card class="mt-0 py-5" elevation="3">
            <v-row align="start" class="px-5">
                <v-col cols="11">
                    <v-row>
                        <v-col
                            v-for="f in selectedFilters"
                            :key="f"
                            :class="getFilterChoiceClassByCode(f)"
                        >
                            <v-text-field
                                v-show="f === 'invoiceNumber'"
                                v-model="filter.invoiceNumber"
                                label="Factuurnummer"
                                clearable
                                hide-details
                                dense
                                class="subtitle-2"
                            ></v-text-field>

                            <v-text-field
                                v-show="f === 'address'"
                                v-model="filter.account_FullAddress"
                                label="Adres"
                                placeholder="Straat / Postcode"
                                clearable
                                hide-details
                                dense
                                class="subtitle-2"
                            ></v-text-field>

                            <v-autocomplete
                                v-show="f === 'sendStatus'"
                                v-model="filter.sendStatusIn"
                                :items="sendStatusChoices"
                                label="Verzendstatus"
                                chips
                                small-chips
                                multiple
                                clearable
                                hide-details
                                dense
                                color="primary"
                                class="subtitle-2"
                            ></v-autocomplete>

                            <v-autocomplete
                                v-show="f === 'invoiceStatus'"
                                v-model="filter.invoiceStatusIn"
                                :items="invoiceStatusChoices"
                                label="Status"
                                chips
                                small-chips
                                clearable
                                multiple
                                hide-details
                                dense
                                color="primary"
                                class="subtitle-2"
                            ></v-autocomplete>

                            <v-autocomplete
                                v-show="f === 'paymentStatus'"
                                v-model="filter.paymentStatusIn"
                                :items="paymentStatusChoices"
                                label="Betaalstatus"
                                chips
                                small-chips
                                clearable
                                multiple
                                hide-details
                                dense
                                color="primary"
                                class="subtitle-2"
                            ></v-autocomplete>

                            <v-select
                                v-show="f === 'relativeDateRange'"
                                v-model="relativeDateRange"
                                :items="relativeDateRangeChoices"
                                label="Relatieve datum"
                                clearable
                                hide-details
                                dense
                                color="primary"
                                class="subtitle-2"
                            ></v-select>

                            <v-menu
                                v-if="f === 'invoiceDate'"
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="savedDateRange"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                :disabled="!!relativeDateRange"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="dateRangeText"
                                        label="Factuurdatum"
                                        readonly
                                        clearable
                                        hide-details
                                        dense
                                        class="subtitle-2"
                                        @click:clear="onClearDates()"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!!relativeDateRange"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateRange"
                                    :first-day-of-week="1"
                                    range
                                    no-title
                                    scrollable
                                    color="primary"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        rounded
                                        color="primary"
                                        @click="cancelDatePicker"
                                    >
                                        Annuleren
                                    </v-btn>
                                    <v-btn
                                        outlined
                                        rounded
                                        color="primary"
                                        :disabled="dateRange.length < 2"
                                        @click="
                                            $refs.menu[0].save(dateRange.sort())
                                        "
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- filters menu -->
                <v-col cols="1" class="py-2 px-0 text-right">
                    <v-menu
                        rounded
                        bottom
                        left
                        key="filterMenu"
                        :close-on-content-click="false"
                        offset-y
                    >
                        <template v-slot:activator="{ attrs, on }">
                            <v-btn class="ma-1" v-bind="attrs" v-on="on" icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-for="item in filterChoices"
                                :key="item.code"
                                class="px-0"
                            >
                                <v-list-item-title class="py-2">
                                    <v-checkbox
                                        v-model="selectedFilters"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code"
                                        hide-details
                                        class="mx-3 my-0"
                                    ></v-checkbox>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-card>

        <!-- data table card -->
        <v-card class="mt-3" elevation="3">
            <v-card-text class="pb-3">
                <v-data-table
                    :headers="headers"
                    :loading="$apollo.queries.serviceInvoices.loading"
                    :items="serviceInvoices.edges"
                    :expanded.sync="expanded"
                    single-expand
                    show-expand
                    item-key="node.id"
                    sort-by="node.invoiceDate"
                    :sort-desc="true"
                    loading-text="Een ogenblik geduld aub..."
                    hide-default-footer
                    disable-pagination
                    @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
                >
                    <!-- data table progress bar -->
                    <template v-slot:progress class="px-0 mx-0">
                        <v-progress-linear
                            absolute
                            height="2"
                            indeterminate
                        ></v-progress-linear>
                    </template>

                    <!-- no data availabel -->
                    <template slot="no-data">
                        <div>Geen gegevens beschikbaar</div>
                    </template>

                    <!-- Address -->
                    <template v-slot:item.node.account.fullAddress="{ item }">
                        <span class="hidden-lg-and-up">{{
                            item.node.account.fullAddress | truncate(30)
                        }}</span>
                        <span class="hidden-md-and-down">{{
                            item.node.account.fullAddress
                        }}</span>
                    </template>

                    <!-- formatted invoice date -->
                    <template v-slot:item.node.invoiceDate="{ item }">
                        <span v-if="item.node.invoiceDate">{{
                            item.node.invoiceDate | moment("DD-MM-YYYY")
                        }}</span>
                    </template>

                    <!-- invoice status -->
                    <template v-slot:item.node.invoiceStatus="{ item }">
                        <v-chip
                            label
                            small
                            :color="
                                item.node.invoiceStatus == 'Definitief'
                                    ? 'success'
                                    : 'primary'
                            "
                            >{{ item.node.invoiceStatus }}</v-chip
                        >
                    </template>

                    <!-- send status -->
                    <template v-slot:item.node.sendStatus="{ item }">
                        <v-chip
                            label
                            small
                            :color="
                                [
                                    'Factuur verzonden',
                                    'Aanmaning verzonden'
                                ].indexOf(item.node.sendStatus) > -1
                                    ? 'success'
                                    : 'primary'
                            "
                            >{{ item.node.sendStatus }}</v-chip
                        >
                    </template>

                    <!-- payment status -->
                    <template v-slot:item.node.paymentStatus="{ item }">
                        <v-chip
                            label
                            small
                            :color="
                                item.node.paymentStatus == 'Betaald'
                                    ? 'success'
                                    : 'primary'
                            "
                            >{{ item.node.paymentStatus }}</v-chip
                        >
                    </template>

                    <!-- download button -->
                    <template
                        v-slot:item.node.annotation.blobStoragePath="{ item }"
                    >
                        <v-btn
                            v-if="
                                item.node.annotation &&
                                    item.node.annotation.blobStoragePath
                            "
                            color="grey darken-2"
                            class="ma-2 white--text"
                            icon
                            download
                            target="_blank"
                            :href="item.node.annotation.blobStoragePath"
                        >
                            <v-icon>
                                file_download
                            </v-icon>
                        </v-btn>
                    </template>

                    <!-- expanded area -->
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="px-5 py-5">
                            <v-row>
                                <v-col cols="6" sm="4" md="2"
                                    ><strong>Klantnummer</strong></v-col
                                >
                                <v-col cols="6" sm="8" md="10">
                                    {{ item.node.account.dynamicsNifenummer }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="4" md="2"
                                    ><strong>Adres</strong></v-col
                                >
                                <v-col cols="6" sm="8" md="10">
                                    {{ item.node.account.fullAddress }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="4" md="2"
                                    ><strong>Abonnement</strong></v-col
                                >
                                <v-col
                                    cols="6"
                                    sm="8"
                                    md="10"
                                    v-if="item.node.subscription"
                                    >{{
                                        item.node.subscription
                                            .subscriptionNumber
                                    }}</v-col
                                >
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="4" md="2"
                                    ><strong>Verzonden op</strong></v-col
                                >
                                <v-col cols="6" sm="8" md="10"
                                    ><span v-if="item.node.sendDate">
                                        {{
                                            item.node.sendDate
                                                | moment("DD-MM-YYYY HH:mm:ss")
                                        }}</span
                                    ></v-col
                                >
                            </v-row>
                            <!-- <v-row>
                                <v-col cols="6" sm="4" md="2"
                                    ><strong>Startdatum</strong></v-col
                                >
                                <v-col cols="6" sm="8" md="9"
                                    ><span v-if="item.node.startDate">
                                        {{
                                            item.node.startDate
                                                | moment("DD-MM-YYYY")
                                        }}</span
                                    ></v-col
                                >
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="4" md="3"
                                    ><strong>Einddatum</strong></v-col
                                >
                                <v-col cols="6" sm="8" md="9"
                                    ><span v-if="item.node.endDate">
                                        {{
                                            item.node.endDate
                                                | moment("DD-MM-YYYY")
                                        }}</span
                                    ></v-col
                                >
                            </v-row> -->
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>

            <!-- infinit loading trigger -->
            <v-card-actions class="justify-center">
                <v-btn
                    v-if="hasMoreData"
                    v-intersect="onLoadMoreTriggerIntersect"
                    :disabled="!hasMoreData"
                    :loading="$apollo.queries.serviceInvoices.loading"
                    text
                    class="mb-5"
                    @click="loadMore"
                >
                    Meer
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>


<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import moment from "moment";

export default {
    title: "Dienstfacturen",
    components: {},

    apollo: {
        serviceInvoices: {
            query: gql`
                query serviceInvoices(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $invoiceNumber: String
                    $account_FullAddress: String
                    $invoiceStatusIn: [String]
                    $sendStatusIn: [String]
                    $paymentStatusIn: [String]
                    $invoiceDateGte: DateTime
                    $invoiceDateLte: DateTime
                    $orderBy: String
                ) {
                    serviceInvoices(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        invoiceNumber_Icontains: $invoiceNumber
                        account_FullAddress_Icontains: $account_FullAddress
                        invoiceStatus_In: $invoiceStatusIn
                        sendStatus_In: $sendStatusIn
                        paymentStatus_In: $paymentStatusIn
                        invoiceDate_Gte: $invoiceDateGte
                        invoiceDate_Lte: $invoiceDateLte
                        orderBy: $orderBy
                    ) {
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                invoiceDate
                                invoiceNumber
                                invoiceStatus
                                sendDate
                                sendStatus
                                paymentStatus
                                account {
                                    id
                                    dynamicsNifenummer
                                    fullAddress
                                }
                                annotation {
                                    id
                                    fileName
                                    blobStoragePath
                                }
                                subscription {
                                    id
                                    subscriptionNumber
                                    dynamicsNifenummer
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return this.filter;
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-first", // this setting can avoid query again after fetchMore
            update: data => data.serviceInvoices,
            watchLoading(isLoading) {
                this.$emit("loading", isLoading);
            },
            skip() {
                return this.me.isStaff;
            }
            // pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            menu: false,
            dateRange: [],
            savedDateRange: [],

            // dynamic filters
            selectedFilters: [
                "invoiceNumber",
                "address",
                "paymentStatus",
                "relativeDateRange"
            ],
            filterChoices: [
                {
                    code: "invoiceNumber",
                    name: "Factuurnummer",
                    class: "col-auto col-md-3 col-lg-2"
                },
                {
                    code: "address",
                    name: "Adres",
                    class: "col-auto col-md-3 col-lg-2"
                },
                {
                    code: "invoiceStatus",
                    name: "Status",
                    class: "col-auto col-md-auto"
                },
                {
                    code: "sendStatus",
                    name: "Verzendstatus",
                    class: "col-auto col-md-auto"
                },
                {
                    code: "paymentStatus",
                    name: "Bestaalstatus",
                    class: "col-auto col-md-auto"
                },
                {
                    code: "relativeDateRange",
                    name: "Relatief datum",
                    class: "col-12 col-sm-6 col-md-5 col-lg-4 col-xl-2"
                },
                {
                    code: "invoiceDate",
                    name: "Factuurdatum",
                    class: "col-12 col-sm-6 col-md-5 col-lg-4 col-xl-2"
                }
            ],

            invoiceStatusChoices: ["Concept", "Definitief"],
            sendStatusChoices: [
                "Factuur verzonden",
                "1e herinnering verzonden",
                "2e herinnering verzonden",
                "Aanmaning verzonden"
            ],
            paymentStatusChoices: [
                "Betaald",
                "Openstaand"
            ],
            relativeDateRange: null,
            relativeDateRangeChoices: [
                // "Vorige maand",
                // "Laatste kwartaal",
                // "Afgelopen half jaar",
                // "Vorig jaar"
                "Afgelopen 1 maand",
                "Afgelopen 3 maanden",
                "Afgelopen 6 maanden",
                "Afgelopen 12 maanden"
            ],

            filter: {
                first: 25,
                after: null,
                invoiceNumber: null,
                account_FullAddress: null,
                invoiceStatusIn: [],
                sendStatusIn: [],
                paymentStatusIn: [],
                invoiceDateGte: null,
                invoiceDateLte: null,
                orderBy: "-invoiceDate"
            },
            expanded: [],
            serviceInvoices: {},

            // infinite loading trigger
            shouldLoadMore: false,

            headers: [
                {
                    text: "Factuurdatum",
                    value: "node.invoiceDate",
                    sortable: true
                },
                {
                    text: "Factuurnummer",
                    align: "left",
                    value: "node.invoiceNumber",
                    sortable: true
                },
                {
                    text: "Status",
                    value: "node.invoiceStatus",
                    sortable: true
                },
                {
                    text: "Verzendstatus",
                    value: "node.sendStatus",
                    sortable: true
                },
                {
                    text: "Betaalstatus",
                    value: "node.paymentStatus",
                    sortable: true
                },
                {
                    text: "Adres",
                    align: "left",
                    value: "node.account.fullAddress",
                    sortable: true
                },
                {
                    text: "PDF",
                    align: "center",
                    value: "node.annotation.blobStoragePath",
                    sortable: false
                },
                { text: "", value: "data-table-expand" }
            ]
        };
    },

    computed: {
        me() {
            return this.$store.state.user.me || {};
        },
        defaultStartDate() {
            // by default, get last 12 months' invoices
            let d = new Date();
            d.setDate(1);
            d.setMonth(d.getMonth() - 60);

            return d;
        },

        dateRangeText() {
            return this.dateRange
                .map(d => {
                    return this.formatDate(d);
                })
                .join(" ~ ");
        },

        // infinite loading
        hasMoreData() {
            return this.serviceInvoices?.pageInfo?.hasNextPage;
        }
    },
    watch: {
        filter: {
            deep: true,

            handler() {
                this.refetchDate();
            }
        },
        // dynamic filters
        selectedFilters: {
            deep: true,

            handler(val) {
                this.updateMyPreferences({ serviceInvoiceFilters: val });
            }
        },
        savedDateRange(val) {
            if (val.length == 1) {
                this.filter.invoiceDateGte = val[0] + "T00:00:00";
                this.filter.invoiceDateLte = val[0] + "T00:00:00";
            } else if (val.length == 2) {
                this.filter.invoiceDateGte = val[0] + "T00:00:00";
                this.filter.invoiceDateLte = val[1] + "T00:00:00";
            } else {
                this.filter.invoiceDateGte = null;
                this.filter.invoiceDateLte = null;
            }
        },
        relativeDateRange(val) {
            const _index = this.relativeDateRangeChoices.indexOf(val);
            let _startDate = null;
            let _endDate = null;
            switch (_index) {
                case 0:
                    // last month
                    _endDate = moment().format("YYYY-MM-DD");
                    _startDate = moment()
                        .date(0)
                        .startOf("month")
                        .format("YYYY-MM-DD");
                    // console.log("_startDate: ", _startDate);
                    // console.log("_endDate:", _endDate);
                    this.dateRange = [_startDate, _endDate];
                    this.savedDateRange = [_startDate, _endDate];
                    break;
                case 1:
                    // last quarter
                    _endDate = moment().format("YYYY-MM-DD");
                    _startDate = moment()
                        .subtract(3, "months")
                        .startOf("month")
                        .format("YYYY-MM-DD");
                    // console.log("_startDate: ", _startDate);
                    // console.log("_endDate:", _endDate);
                    this.dateRange = [_startDate, _endDate];
                    this.savedDateRange = [_startDate, _endDate];
                    break;
                case 2:
                    // last half year
                    _endDate = moment().format("YYYY-MM-DD");
                    _startDate = moment()
                        .subtract(6, "months")
                        .startOf("month")
                        .format("YYYY-MM-DD");
                    // console.log("_startDate: ", _startDate);
                    // console.log("_endDate:", _endDate);
                    this.dateRange = [_startDate, _endDate];
                    this.savedDateRange = [_startDate, _endDate];
                    break;
                case 3:
                    // last 1 year
                    _endDate = moment().format("YYYY-MM-DD");
                    _startDate = moment()
                        .subtract(12, "months")
                        .startOf("month")
                        .format("YYYY-MM-DD");
                    // console.log("_startDate: ", _startDate);
                    // console.log("_endDate:", _endDate);
                    this.dateRange = [_startDate, _endDate];
                    this.savedDateRange = [_startDate, _endDate];
                    break;
                default:
                    this.dateRange = [];
                    this.savedDateRange = [];
            }
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        // dynamic filters
        if (this.me.preferences) {
            try {
                const _preferences = JSON.parse(this.me.preferences);
                if (_preferences.serviceInvoiceFilters) {
                    // filter out old choice
                    this.selectedFilters = _preferences.serviceInvoiceFilters.filter(
                        item => {
                            return this.filterChoices.some(
                                elem => elem.code === item
                            );
                        }
                    );
                }
            } catch (e) {
                console.error(e);
            }
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        cancelDatePicker() {
            this.menu = false;
            if (this.savedDateRange.length == 0) {
                this.dateRange = [];
            }
        },
        onClearDates() {
            this.dateRange = [];
            this.savedDateRange = [];
        },
        // infinite loading trigger
        onLoadMoreTriggerIntersect(entries) {
            this.shouldLoadMore = entries[0].isIntersecting;

            if (
                this.shouldLoadMore &&
                this.serviceInvoices?.pageInfo?.hasNextPage
            ) {
                this.loadMore();
            }
        },
        refetchDate() {
            // use timeout to debouce
            if (this.timeout) clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.$apollo.queries.serviceInvoices.refetch(this.filter);
            }, 800); // delay
        },
        loadMore() {
            if (this.serviceInvoices?.pageInfo?.hasNextPage) {
                this.$apollo.queries.serviceInvoices.fetchMore({
                    variables: {
                        after: this.serviceInvoices.pageInfo.endCursor
                    }
                });
            }
        },
        // dynamic filter
        getFilterChoiceClassByCode(code) {
            return this.filterChoices.find(item => {
                return item.code === code;
            })?.class;
        },
        // update filter preferences
        updateMyPreferences(value) {
            let _preferences = JSON.parse(this.me.preferences);
            _preferences = Object.assign(_preferences || {}, value);

            this.$store
                .dispatch("user/updateMyPreferences", {
                    preferences: JSON.stringify(_preferences)
                })
                .then(() => {
                    this.$store
                        .dispatch("user/fetchMe")
                        .then(() => {})
                        .catch(error => {
                            console.log("fetchMe catched error: ", error);
                        });
                })
                .catch(error => {
                    console.log("updateMyPreferences catched error: ", error);
                });
        }
    }
};
</script>